import { BinType, MaxBinsSortOrder, QuantileState } from "./groupBy";

export type MaxBinsSortAggregation = "Sum" | "Average" | "Min" | "Max";

export class mBinSize {
  BinSize: number | "";
  LessThan: number | string | null;
  GreaterThan: number | string | null;
  MinSize: number | "";
  MaxBins?: number | "";
  MaxBinsSortOrder?: MaxBinsSortOrder;
  // The numeric field "Sum of…" ranks by; only read when MaxBinsSortOrder is FieldSum.
  MaxBinsSortField?: string;
  // Request-only: proxies.ts sets it for Link to Axis, and it is never stored.
  MaxBinsSortAggregation?: MaxBinsSortAggregation;
  // Category-axis UI state: proxies.ts resolves it and never sends it. On the stacked bar
  // category axis only an explicit false means not linked.
  MaxBinsLinkToAxis?: boolean;
  Quantile?: QuantileState;
  BinType: BinType = "BinSize";
  IsLocked?: boolean = false;
  UseDynamicBins?: boolean = false;

  constructor(MinSize, LessThan, BinSize, GreaterThan) {
    this.BinSize = BinSize;
    this.LessThan = LessThan;
    this.GreaterThan = GreaterThan;
    this.MinSize = MinSize;
  }
}

export enum MaxBinsSortOrderEnum {
  WellCount = "WellCount",
  // Legacy: still honoured for saved bins, no longer offered in the UI.
  Production = "Production",
  FieldSum = "FieldSum"
}

export interface BinSize {
  BinSize: Nullable<number>;
  LessThan: Nullable<number>;
  GreaterThan: Nullable<number>;
  MinSize: Nullable<number>;
  MaxBins?: Nullable<number>;
  MaxBinsSortOrder?: MaxBinsSortOrderEnum;
  MaxBinsSortField?: string;
  MaxBinsSortAggregation?: MaxBinsSortAggregation;
  MaxBinsLinkToAxis?: boolean;
  Quantile?: QuantileState;
  BinType: BinType;
  IsLocked?: boolean;
  UseDynamicBins?: boolean;
}
